// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__YNBwS","alertIcon":"ConfirmModal_alertIcon__1hxTJ"};